export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("app:chunkError", () => {
    throw createError({
      statusCode: 500,
      statusMessage: "Chunk error detected",
    });
  })

  nuxtApp.hook('vue:error', (_, instance, info) => {
    const { appEnv } = useRuntimeConfig().public;
    const error = useError();

    if (error.value?.statusCode && error.value?.statusCode != 404 && appEnv == 'production') {
      console.log(`Error detected at: ${useRoute().path}`)
    }
  })
})
